import "./HealthStateIndicator.scss";

interface IProps {
  healthIndicatorState?: { status: 0 | 1 | 2; messages: string[] };
}

const HealthStateIndicator = ({
  healthIndicatorState
}: IProps) => {
const healthState = healthIndicatorState?.status ?? 0;
const errorMessage = healthIndicatorState?.messages?.length
    ? healthIndicatorState.messages
    : ["Some permissions are missing. Please check the operator's permissions. If you are not sure, please contact support."];

// Rectangle colors
const getRectColor = (index: number) => {
    if (healthState === 2) {
        return "#4CAF50";
    }
    if (healthState === 1) {
        return index < 2 ? "#FFC107" : "#E0E0E0";
    }
    if (healthState === 0) {
        return index === 0 ? "#F44336" : "#E0E0E0";
    }
    return "#E0E0E0";
};

const isHealthOk = healthState === 2;

const HealthStateMeter = () => (
    <div className="health-state-meter">
        <label className="health-state-label">Health State</label>
        <div className="health-state-bars">
            {[0, 1, 2].map((idx) => (
                <div
                    key={idx}
                    className="health-state-bar"
                    style={{ background: getRectColor(idx) }}
                />
            ))}
        </div>
    </div>
);

return (
    <div className="health-state-indicator-container">
        <HealthStateMeter />
        {!isHealthOk && (
            <div className="health-state-warning-row">
                <span title="Warning" className="health-state-warning-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" style={{ display: "block" }}>
                        <polygon
                            points="10,2 19,18 1,18"
                            fill="#FFFFFF"
                            stroke="#757575"
                            strokeWidth="2.2"
                        />
                        <rect x="9" y="7" width="2" height="5" fill="#757575" />
                        <rect x="9" y="14" width="2" height="2" fill="#757575" />
                    </svg>
                </span>
                <div className="health-state-warning-message">
                    {errorMessage.map((msg, idx) => (
                        <div key={idx}>{msg}</div>
                    ))}
                </div>
            </div>
        )}
    </div>
);
};

export default HealthStateIndicator;

